import React from 'react';
import Svg, { Path } from 'react-native-svg';

export const NotificationMenuIcon = ({
  color = '#3F3F3F',
  hasNotifications = false,
}) => (
  <Svg width="36" height="32" viewBox="0 0 36 32" fill="none">
    <Path
      d="M16.8438 22C16.9608 22.2027 17.1291 22.371 17.3318 22.488C17.5345 22.605 17.7644 22.6666 17.9984 22.6666C18.2325 22.6666 18.4624 22.605 18.6651 22.488C18.8677 22.371 19.0361 22.2027 19.1531 22"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M12.1742 18.218C12.0871 18.3134 12.0296 18.4321 12.0087 18.5597C11.9879 18.6872 12.0045 18.818 12.0567 18.9363C12.1088 19.0545 12.1941 19.155 12.3023 19.2256C12.4106 19.2962 12.537 19.3339 12.6662 19.334H23.3328C23.462 19.334 23.5885 19.2965 23.6968 19.2261C23.805 19.1556 23.8905 19.0552 23.9428 18.937C23.995 18.8188 24.0118 18.688 23.9911 18.5605C23.9704 18.433 23.9131 18.3142 23.8262 18.2187C22.9395 17.3047 21.9995 16.3333 21.9995 13.334C21.9995 12.2731 21.5781 11.2557 20.8279 10.5056C20.0778 9.75541 19.0604 9.33398 17.9995 9.33398C16.9386 9.33398 15.9212 9.75541 15.1711 10.5056C14.4209 11.2557 13.9995 12.2731 13.9995 13.334C13.9995 16.3333 13.0588 17.3047 12.1742 18.218Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {hasNotifications && (
      <Path
        d="M24 8C24 5.79086 25.7909 4 28 4C30.2091 4 32 5.79086 32 8C32 10.2091 30.2091 12 28 12C25.7909 12 24 10.2091 24 8Z"
        fill="#2B78CA"
      />
    )}
    {hasNotifications && (
      <Path
        d="M24 8C24 5.79086 25.7909 4 28 4C30.2091 4 32 5.79086 32 8C32 10.2091 30.2091 12 28 12C25.7909 12 24 10.2091 24 8Z"
        fill="#2B78CA"
      />
    )}
  </Svg>
);
